import { __decorate, __param } from 'tslib';
import { HttpResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable, InjectionToken, Inject, Optional, SkipSelf, APP_INITIALIZER, NgModule } from '@angular/core';
import { tap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
let MiniProfilerInterceptor = class MiniProfilerInterceptor {
    intercept(request, next) {
        return next.handle(request).pipe(tap(evt => {
            if (!(evt instanceof HttpResponse)) {
                return;
            }
            try {
                const miniProfilerHeaders = JSON.parse(evt.headers.get('X-MiniProfiler-Ids'));
                this.fetchMiniProfilerResults(miniProfilerHeaders);
            }
            catch (_a) { }
        }));
    }
    fetchMiniProfilerResults(ids) {
        if (typeof MiniProfiler == null) {
            return;
        }
        if (ids == null) {
            return;
        }
        MiniProfiler.fetchResults(ids);
    }
};
MiniProfilerInterceptor.ɵfac = function MiniProfilerInterceptor_Factory(t) { return new (t || MiniProfilerInterceptor)(); };
MiniProfilerInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MiniProfilerInterceptor, factory: function (t) { return MiniProfilerInterceptor.ɵfac(t); } });

const MINI_PROFILER_CONFIG = new InjectionToken('MiniProfilerConfig');
let MiniProfilerService = class MiniProfilerService {
    constructor(config, other) {
        this.config = config;
        if (other) {
            throw new Error('MiniProfilerService should only be instanciated once.');
        }
        if (this.config.enableGlobalMethod !== false) {
            window['enableMiniProfiler'] = () => this.loadMiniProfiler(true);
        }
    }
    loadMiniProfiler(force = false) {
        if (!force && !this.config.enabled) {
            return;
        }
        if (document.getElementById('mini-profiler')) {
            throw new Error(`An element with id 'mini-profiler' already is already present in the DOM.`);
        }
        const scriptElement = document.createElement('script');
        scriptElement.id = 'mini-profiler';
        scriptElement.async = true;
        scriptElement.type = 'text/javascript';
        scriptElement.src = `${this.config.baseUri}/mini-profiler-resources/includes.min.js`;
        scriptElement.dataset.path = `${this.config.baseUri}/mini-profiler-resources/`;
        scriptElement.dataset.position = this.config.position || 'Left';
        scriptElement.dataset.scheme = this.config.colorScheme || 'Auto';
        scriptElement.dataset.controls = `${this.config.showControls === true}`;
        scriptElement.dataset.authorized = 'true';
        scriptElement.dataset.maxTraces = this.config.maxTraces == null ? '15' : `${this.config.maxTraces}`;
        scriptElement.dataset.toggleShortcut = this.config.toggleShortcut || 'Alt+M';
        scriptElement.onload = () => console.log('MiniProfiler loaded.');
        scriptElement.onerror = (err) => console.error('An error occured while loading MiniProfiler', err);
        document.getElementsByTagName('body')[0].appendChild(scriptElement);
    }
};
MiniProfilerService.ɵfac = function MiniProfilerService_Factory(t) { return new (t || MiniProfilerService)(ɵngcc0.ɵɵinject(MINI_PROFILER_CONFIG), ɵngcc0.ɵɵinject(MiniProfilerService, 12)); };
MiniProfilerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MiniProfilerService, factory: function (t) { return MiniProfilerService.ɵfac(t); } });
MiniProfilerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MINI_PROFILER_CONFIG,] }] },
    { type: MiniProfilerService, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
MiniProfilerService = __decorate([ __param(0, Inject(MINI_PROFILER_CONFIG)),
    __param(1, Optional()), __param(1, SkipSelf())
], MiniProfilerService);

var MiniProfilerModule_1;
let MiniProfilerModule = MiniProfilerModule_1 = class MiniProfilerModule {
    static forRoot(config) {
        return {
            ngModule: MiniProfilerModule_1,
            providers: [
                MiniProfilerService,
                { provide: MINI_PROFILER_CONFIG, useValue: config },
                { provide: HTTP_INTERCEPTORS, useClass: MiniProfilerInterceptor, multi: true },
                {
                    provide: APP_INITIALIZER,
                    multi: true,
                    deps: [MiniProfilerService],
                    useFactory: loadMiniProfilerFactory
                }
            ]
        };
    }
};
MiniProfilerModule.ɵfac = function MiniProfilerModule_Factory(t) { return new (t || MiniProfilerModule)(); };
MiniProfilerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MiniProfilerModule });
MiniProfilerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MiniProfilerInterceptor, [{
        type: Injectable
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MiniProfilerService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MINI_PROFILER_CONFIG]
            }] }, { type: MiniProfilerService, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MiniProfilerModule, [{
        type: NgModule
    }], null, null); })();
function loadMiniProfilerFactory(service) {
    const init = () => loadMiniProfiler(service);
    return init;
}
function loadMiniProfiler(service) {
    service.loadMiniProfiler();
}

/*
 * Public API Surface of ng-miniprofiler
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MiniProfilerInterceptor, MiniProfilerModule, loadMiniProfiler, loadMiniProfilerFactory, MINI_PROFILER_CONFIG as ɵa, MiniProfilerService as ɵb };

